// Multilingual SEO keywords for every service + sub-service.
// Coverage: 20 main services × 20 languages.
// Used by ServiceAreas component and service detail pages for SEO indexing.
//
// Languages: en, es, fr, de, it, pt, nl, pl, ru, sv, no, el, ar, hi, zh, ja, id, ms, tl, vi

export const SERVICES_KEYWORDS = [
  {
    slug: 'land-surveying',
    name: 'Land Surveying',
    subServices: ['Boundary survey', 'Topographic survey', 'ALTA/NSPS', 'As-built survey', 'Subdivision survey', 'Mortgage survey', 'Construction staking'],
    t: {
      en: 'land surveying services', es: 'servicios de topografía', fr: 'services d\'arpentage', de: 'Vermessungsdienste', it: 'servizi di rilievo', pt: 'serviços de topografia',
      nl: 'landmeetkundige diensten', pl: 'usługi geodezyjne', ru: 'геодезические услуги', sv: 'lantmäteritjänster', no: 'oppmålingstjenester', el: 'υπηρεσίες τοπογραφίας',
      ar: 'خدمات مسح الأراضي', hi: 'भूमि सर्वेक्षण सेवाएं', zh: '土地测量服务', ja: '土地測量サービス',
      id: 'jasa survei tanah', ms: 'perkhidmatan ukur tanah', tl: 'mga serbisyo sa pagsusukat ng lupa', vi: 'dịch vụ khảo sát đất'
    }
  },
  {
    slug: 'land-development',
    name: 'Land Development',
    subServices: ['Site planning', 'Subdivision design', 'Grading & drainage plans', 'Erosion & sediment control', 'Stormwater management', 'Utility coordination', 'Lot layout', 'Master planning', 'Roadway design', 'Site plan approval'],
    t: {
      en: 'land development services', es: 'desarrollo de terrenos', fr: 'aménagement foncier', de: 'Grundstücksentwicklung', it: 'sviluppo del territorio', pt: 'desenvolvimento de terrenos',
      nl: 'landontwikkeling', pl: 'rozwój gruntów', ru: 'освоение земель', sv: 'markutveckling', no: 'arealutvikling', el: 'ανάπτυξη γης',
      ar: 'تطوير الأراضي', hi: 'भूमि विकास', zh: '土地开发', ja: '土地開発',
      id: 'pengembangan lahan', ms: 'pembangunan tanah', tl: 'pag-unlad ng lupa', vi: 'phát triển đất'
    }
  },
  {
    slug: 'bim-services',
    name: 'BIM Services',
    subServices: ['BIM Execution Plan (BEP)', 'Clash detection', '4D scheduling', '5D cost', 'Scan-to-BIM', 'Revit family creation', 'BIM coordination', 'LOD 100-500 modeling'],
    t: {
      en: 'BIM modeling services', es: 'modelado BIM', fr: 'modélisation BIM', de: 'BIM-Modellierung', it: 'modellazione BIM', pt: 'modelagem BIM',
      nl: 'BIM-modellering', pl: 'modelowanie BIM', ru: 'BIM-моделирование', sv: 'BIM-modellering', no: 'BIM-modellering', el: 'υπηρεσίες BIM',
      ar: 'نمذجة BIM', hi: 'बीआईएम मॉडलिंग', zh: 'BIM建模服务', ja: 'BIMモデリング',
      id: 'layanan pemodelan BIM', ms: 'perkhidmatan pemodelan BIM', tl: 'mga serbisyo sa BIM', vi: 'dịch vụ mô hình hóa BIM'
    }
  },
  {
    slug: '3d-modeling',
    name: '3D Modeling',
    subServices: ['Architectural 3D', 'Product modeling', '3D rendering', 'Photorealistic visualization', 'Virtual tours', 'Real-estate walkthroughs', '3D printing prep'],
    t: {
      en: '3D modeling & visualization', es: 'modelado 3D y visualización', fr: 'modélisation 3D', de: '3D-Modellierung', it: 'modellazione 3D', pt: 'modelagem 3D',
      nl: '3D-modellering', pl: 'modelowanie 3D', ru: '3D-моделирование', sv: '3D-modellering', no: '3D-modellering', el: '3D μοντελοποίηση',
      ar: 'النمذجة ثلاثية الأبعاد', hi: '3डी मॉडलिंग', zh: '3D建模与可视化', ja: '3Dモデリング',
      id: 'pemodelan 3D', ms: 'pemodelan 3D', tl: '3D modeling', vi: 'mô hình hóa 3D'
    }
  },
  {
    slug: 'steel-detailing',
    name: 'Steel Detailing',
    subServices: ['Shop drawings', 'Erection drawings', 'Connection design', 'Misc steel', 'Stair & railing', 'Anchor bolt plans', 'Tekla modeling', 'Rebar detailing'],
    t: {
      en: 'structural steel detailing', es: 'detallado de acero estructural', fr: 'détaillage métallique', de: 'Stahlbau-Detailplanung', it: 'progettazione di dettaglio acciaio', pt: 'detalhamento estrutural',
      nl: 'staaldetaillering', pl: 'detalowanie konstrukcji stalowych', ru: 'деталировка металлоконструкций', sv: 'stålritning', no: 'ståltegninger', el: 'λεπτομέρειες χάλυβα',
      ar: 'تفصيل الفولاذ الإنشائي', hi: 'स्टील डिटेलिंग', zh: '钢结构详图', ja: '鉄骨詳細設計',
      id: 'detailing baja', ms: 'perincian keluli', tl: 'steel detailing', vi: 'chi tiết kết cấu thép'
    }
  },
  {
    slug: 'engineering-designs',
    name: 'Engineering Designs',
    subServices: ['Concept design', 'Feasibility studies', 'Schematic design', 'Design development', 'Construction documents', 'Engineering calculations', 'Specifications'],
    t: {
      en: 'engineering design services', es: 'servicios de diseño de ingeniería', fr: 'études d\'ingénierie', de: 'Ingenieurleistungen', it: 'progettazione ingegneristica', pt: 'projetos de engenharia',
      nl: 'engineering ontwerp', pl: 'projektowanie inżynierskie', ru: 'инженерное проектирование', sv: 'ingenjörsdesign', no: 'ingeniørdesign', el: 'υπηρεσίες μηχανικής σχεδίασης',
      ar: 'خدمات التصميم الهندسي', hi: 'इंजीनियरिंग डिज़ाइन', zh: '工程设计服务', ja: 'エンジニアリング設計',
      id: 'desain teknik', ms: 'reka bentuk kejuruteraan', tl: 'engineering design', vi: 'thiết kế kỹ thuật'
    }
  },
  {
    slug: 'architectural',
    name: 'Architectural Services',
    subServices: ['Floor plans', 'Elevations', 'Sections', 'Construction documentation', 'Permit drawings', 'Space planning', '3D renderings', 'Interior design'],
    t: {
      en: 'architectural design services', es: 'diseño arquitectónico', fr: 'services d\'architecture', de: 'Architekturleistungen', it: 'progettazione architettonica', pt: 'projeto arquitetônico',
      nl: 'architectonisch ontwerp', pl: 'projekty architektoniczne', ru: 'архитектурные услуги', sv: 'arkitekttjänster', no: 'arkitekttjenester', el: 'αρχιτεκτονικός σχεδιασμός',
      ar: 'الخدمات المعمارية', hi: 'वास्तुकला सेवाएं', zh: '建筑设计服务', ja: '建築設計',
      id: 'jasa arsitektur', ms: 'perkhidmatan seni bina', tl: 'serbisyong arkitektura', vi: 'dịch vụ kiến trúc'
    }
  },
  {
    slug: 'civil-engineering',
    name: 'Civil Engineering',
    subServices: ['Site grading', 'Roadway design', 'Drainage design', 'Utility design', 'Sewer & water', 'Erosion control', 'Pavement design', 'Earthworks'],
    t: {
      en: 'civil engineering services', es: 'ingeniería civil', fr: 'génie civil', de: 'Bauingenieurwesen', it: 'ingegneria civile', pt: 'engenharia civil',
      nl: 'civiele techniek', pl: 'inżynieria lądowa', ru: 'гражданское строительство', sv: 'väg- och vattenbyggnad', no: 'sivilingeniørtjenester', el: 'πολιτικός μηχανικός',
      ar: 'الهندسة المدنية', hi: 'सिविल इंजीनियरिंग', zh: '土木工程', ja: '土木工学',
      id: 'teknik sipil', ms: 'kejuruteraan awam', tl: 'inhinyeriyang sibil', vi: 'kỹ thuật xây dựng'
    }
  },
  {
    slug: 'mechanical-engineering',
    name: 'Mechanical Engineering',
    subServices: ['HVAC design', 'Plumbing layout', 'Fire protection', 'Sheet metal', 'Piping design', 'Mechanical calculations', 'Energy modeling'],
    t: {
      en: 'mechanical engineering services', es: 'ingeniería mecánica', fr: 'génie mécanique', de: 'Maschinenbau', it: 'ingegneria meccanica', pt: 'engenharia mecânica',
      nl: 'werktuigbouwkunde', pl: 'inżynieria mechaniczna', ru: 'машиностроение', sv: 'maskinteknik', no: 'maskinteknikk', el: 'μηχανολογία',
      ar: 'الهندسة الميكانيكية', hi: 'मैकेनिकल इंजीनियरिंग', zh: '机械工程', ja: '機械工学',
      id: 'teknik mesin', ms: 'kejuruteraan mekanikal', tl: 'mechanical engineering', vi: 'kỹ thuật cơ khí'
    }
  },
  {
    slug: 'manufacturing',
    name: 'Manufacturing Engineering',
    subServices: ['Production design', 'CNC programming', 'Tooling design', 'Jig & fixture', 'Process planning', 'CAM design', 'Quality engineering'],
    t: {
      en: 'manufacturing engineering services', es: 'ingeniería de manufactura', fr: 'ingénierie de fabrication', de: 'Fertigungstechnik', it: 'ingegneria di produzione', pt: 'engenharia de manufatura',
      nl: 'productietechniek', pl: 'inżynieria produkcji', ru: 'производственное проектирование', sv: 'tillverkningsteknik', no: 'produksjonsteknikk', el: 'μηχανική παραγωγής',
      ar: 'هندسة التصنيع', hi: 'विनिर्माण इंजीनियरिंग', zh: '制造工程', ja: '製造エンジニアリング',
      id: 'teknik manufaktur', ms: 'kejuruteraan pembuatan', tl: 'manufacturing engineering', vi: 'kỹ thuật sản xuất'
    }
  },
  {
    slug: 'process-equipment',
    name: 'Process Equipment Design',
    subServices: ['Pressure vessels', 'Storage tanks', 'Heat exchangers', 'PV Elite analysis', 'ASME compliance', 'Reactor design', 'Skid packages'],
    t: {
      en: 'process equipment design', es: 'diseño de equipos de proceso', fr: 'conception d\'équipements de procédé', de: 'Verfahrenstechnik', it: 'progettazione apparecchiature di processo', pt: 'projeto de equipamentos',
      nl: 'procesapparatuur ontwerp', pl: 'projektowanie aparatury procesowej', ru: 'проектирование оборудования', sv: 'processutrustning', no: 'prosessutstyr', el: 'σχεδίαση εξοπλισμού διεργασιών',
      ar: 'تصميم معدات العمليات', hi: 'प्रक्रिया उपकरण डिज़ाइन', zh: '工艺设备设计', ja: 'プロセス機器設計',
      id: 'desain peralatan proses', ms: 'reka bentuk peralatan proses', tl: 'process equipment design', vi: 'thiết kế thiết bị quá trình'
    }
  },
  {
    slug: 'plant-engineering',
    name: 'Plant Engineering',
    subServices: ['Plant layout', '3D plant modeling', 'Piping design', 'P&ID', 'Equipment placement', 'AutoCAD Plant 3D', 'SmartPlant SP3D'],
    t: {
      en: 'plant engineering services', es: 'ingeniería de plantas', fr: 'ingénierie d\'usine', de: 'Anlagenbau', it: 'ingegneria di impianti', pt: 'engenharia de plantas',
      nl: 'fabrieksengineering', pl: 'inżynieria zakładów', ru: 'проектирование заводов', sv: 'anläggningsteknik', no: 'anleggsteknikk', el: 'μηχανική εγκαταστάσεων',
      ar: 'هندسة المصانع', hi: 'प्लांट इंजीनियरिंग', zh: '工厂工程', ja: 'プラントエンジニアリング',
      id: 'teknik pabrik', ms: 'kejuruteraan loji', tl: 'plant engineering', vi: 'kỹ thuật nhà máy'
    }
  },
  {
    slug: 'environmental-engineering',
    name: 'Environmental Engineering',
    subServices: ['Water treatment', 'Wastewater treatment', 'Solid waste management', 'Air quality', 'Renewable energy', 'Hydrogeology', 'EIA studies'],
    t: {
      en: 'environmental engineering', es: 'ingeniería ambiental', fr: 'ingénierie environnementale', de: 'Umwelttechnik', it: 'ingegneria ambientale', pt: 'engenharia ambiental',
      nl: 'milieutechniek', pl: 'inżynieria środowiska', ru: 'инженерная экология', sv: 'miljöteknik', no: 'miljøteknikk', el: 'περιβαλλοντική μηχανική',
      ar: 'الهندسة البيئية', hi: 'पर्यावरण इंजीनियरिंग', zh: '环境工程', ja: '環境工学',
      id: 'teknik lingkungan', ms: 'kejuruteraan alam sekitar', tl: 'environmental engineering', vi: 'kỹ thuật môi trường'
    }
  },
  {
    slug: 'water-wastewater',
    name: 'Water & Drainage',
    subServices: ['Water supply networks', 'Sewer systems', 'Stormwater drainage', 'Hydraulic modeling', 'HEC-RAS / HEC-HMS', 'Pump stations', 'Detention basins'],
    t: {
      en: 'water & drainage engineering', es: 'ingeniería de agua y drenaje', fr: 'génie de l\'eau et drainage', de: 'Wasser- und Entwässerungstechnik', it: 'ingegneria idraulica', pt: 'engenharia hidráulica',
      nl: 'water- en drainagetechniek', pl: 'inżynieria wodna', ru: 'водоснабжение и канализация', sv: 'vatten- och avloppsteknik', no: 'vann og avløp', el: 'υδραυλική μηχανική',
      ar: 'هندسة المياه والصرف', hi: 'जल और जल निकासी', zh: '给排水工程', ja: '上下水道工学',
      id: 'teknik air dan drainase', ms: 'kejuruteraan air dan saliran', tl: 'water and drainage engineering', vi: 'kỹ thuật cấp thoát nước'
    }
  },
  {
    slug: 'transportation',
    name: 'Transportation Infrastructure',
    subServices: ['Highway design', 'Road & corridor design', 'Rail infrastructure', 'Traffic analysis', 'Bridge design', 'Intersection design', 'Pavement engineering'],
    t: {
      en: 'transportation engineering', es: 'ingeniería de transporte', fr: 'ingénierie des transports', de: 'Verkehrstechnik', it: 'ingegneria dei trasporti', pt: 'engenharia de transportes',
      nl: 'verkeerstechniek', pl: 'inżynieria transportu', ru: 'транспортная инфраструктура', sv: 'transportteknik', no: 'transportteknikk', el: 'συγκοινωνιακή μηχανική',
      ar: 'هندسة النقل', hi: 'परिवहन इंजीनियरिंग', zh: '交通工程', ja: '交通工学',
      id: 'teknik transportasi', ms: 'kejuruteraan pengangkutan', tl: 'transportation engineering', vi: 'kỹ thuật giao thông'
    }
  },
  {
    slug: 'structural-engineering',
    name: 'Structural Engineering',
    subServices: ['Building structures', 'Bridge engineering', 'Foundation design', 'Seismic analysis', 'Steel & concrete', 'Industrial facilities', 'Retaining walls'],
    t: {
      en: 'structural engineering services', es: 'ingeniería estructural', fr: 'ingénierie structurelle', de: 'Tragwerksplanung', it: 'ingegneria strutturale', pt: 'engenharia estrutural',
      nl: 'constructieve techniek', pl: 'inżynieria konstrukcyjna', ru: 'строительное проектирование', sv: 'konstruktionsteknik', no: 'bærekonstruksjoner', el: 'στατική μηχανική',
      ar: 'الهندسة الإنشائية', hi: 'संरचनात्मक इंजीनियरिंग', zh: '结构工程', ja: '構造工学',
      id: 'teknik struktur', ms: 'kejuruteraan struktur', tl: 'structural engineering', vi: 'kỹ thuật kết cấu'
    }
  },
  {
    slug: 'gis-geospatial',
    name: 'GIS & Geospatial',
    subServices: ['ArcGIS mapping', 'LiDAR processing', 'Drone mapping', 'Geospatial analysis', 'Cadastral mapping', 'Asset GIS', 'Smart city GIS'],
    t: {
      en: 'GIS & geospatial services', es: 'servicios SIG y geoespaciales', fr: 'services SIG et géospatiaux', de: 'GIS und Geodatendienste', it: 'servizi GIS', pt: 'serviços SIG',
      nl: 'GIS-diensten', pl: 'usługi GIS', ru: 'ГИС и геопространственные услуги', sv: 'GIS-tjänster', no: 'GIS-tjenester', el: 'υπηρεσίες GIS',
      ar: 'خدمات GIS والجيومكانية', hi: 'जीआईएस सेवाएं', zh: 'GIS地理空间服务', ja: 'GISサービス',
      id: 'layanan GIS', ms: 'perkhidmatan GIS', tl: 'GIS at geospatial services', vi: 'dịch vụ GIS'
    }
  },
  {
    slug: 'graphics-services',
    name: 'Graphics & Creative',
    subServices: ['Photorealistic rendering', 'Animation', '3D walkthroughs', 'Illustration', 'Marketing visuals', 'Product visualization', 'Architectural rendering'],
    t: {
      en: 'graphics & creative services', es: 'servicios gráficos y creativos', fr: 'services graphiques et créatifs', de: 'Grafik- und Kreativdienste', it: 'servizi grafici e creativi', pt: 'serviços gráficos',
      nl: 'grafische diensten', pl: 'usługi graficzne', ru: 'графические и креативные услуги', sv: 'grafiska tjänster', no: 'grafiske tjenester', el: 'γραφιστικές υπηρεσίες',
      ar: 'الخدمات الجرافيكية والإبداعية', hi: 'ग्राफिक्स सेवाएं', zh: '图形与创意服务', ja: 'グラフィックサービス',
      id: 'layanan grafis', ms: 'perkhidmatan grafik', tl: 'graphics at creative services', vi: 'dịch vụ đồ họa'
    }
  },
  {
    slug: 'signage-engineering',
    name: 'Signage Engineering',
    subServices: ['Digital signage', 'ADA compliant signage', 'LED design', 'Wayfinding', 'Sai Flexi', 'LED Wizard', 'Channel letter design'],
    t: {
      en: 'signage engineering services', es: 'ingeniería de señalización', fr: 'ingénierie de signalisation', de: 'Beschilderungstechnik', it: 'ingegneria della segnaletica', pt: 'engenharia de sinalização',
      nl: 'bewegwijzering', pl: 'inżynieria oznakowania', ru: 'проектирование вывесок', sv: 'skyltteknik', no: 'skiltteknikk', el: 'μηχανική σήμανσης',
      ar: 'هندسة اللافتات', hi: 'साइनेज इंजीनियरिंग', zh: '标识工程', ja: 'サイネージエンジニアリング',
      id: 'teknik signage', ms: 'kejuruteraan papan tanda', tl: 'signage engineering', vi: 'kỹ thuật biển báo'
    }
  },
  {
    slug: 'mep-engineering',
    name: 'MEP Engineering',
    subServices: ['Mechanical design', 'Electrical design', 'Plumbing design', 'Fire protection', 'Building automation', 'Energy modeling', 'LEED compliance'],
    t: {
      en: 'MEP engineering services', es: 'ingeniería MEP', fr: 'ingénierie MEP', de: 'TGA-Planung', it: 'ingegneria MEP', pt: 'engenharia MEP',
      nl: 'MEP-techniek', pl: 'inżynieria MEP', ru: 'MEP-инженерия', sv: 'MEP-teknik', no: 'MEP-teknikk', el: 'μηχανική MEP',
      ar: 'هندسة الكهروميكانيكية والسباكة', hi: 'एमईपी इंजीनियरिंग', zh: '机电管道工程', ja: 'MEPエンジニアリング',
      id: 'teknik MEP', ms: 'kejuruteraan MEP', tl: 'MEP engineering', vi: 'kỹ thuật MEP'
    }
  },
  {
    slug: 'facility-management',
    name: 'Building Facility Management',
    subServices: ['Asset tagging', 'Space utilization studies', 'FM-ready BIM (COBie)', 'CAFM integration', 'O&M documentation', 'Preventive maintenance schedules', 'Building lifecycle costing'],
    t: {
      en: 'building facility management', es: 'gestión de instalaciones', fr: 'gestion d\'installations', de: 'Facility Management', it: 'gestione strutture', pt: 'gestão de instalações',
      nl: 'facilitair beheer', pl: 'zarządzanie obiektami', ru: 'управление объектами', sv: 'fastighetsförvaltning', no: 'eiendomsforvaltning', el: 'διαχείριση εγκαταστάσεων',
      ar: 'إدارة المرافق', hi: 'सुविधा प्रबंधन', zh: '设施管理', ja: 'ファシリティマネジメント',
      id: 'manajemen fasilitas', ms: 'pengurusan kemudahan', tl: 'facility management', vi: 'quản lý cơ sở'
    }
  },
  {
    slug: 'construction-engineering',
    name: 'Construction Engineering',
    subServices: ['Construction documentation', 'Permit drawings', 'Site coordination drawings', 'Shop drawing review', 'As-built drawings', 'Quantity take-offs', 'Constructability review'],
    t: {
      en: 'construction engineering services', es: 'ingeniería de construcción', fr: 'ingénierie de construction', de: 'Bauingenieurleistungen', it: 'ingegneria delle costruzioni', pt: 'engenharia de construção',
      nl: 'bouwkundige techniek', pl: 'inżynieria budowlana', ru: 'строительная инженерия', sv: 'byggnadsteknik', no: 'bygningsteknikk', el: 'μηχανική κατασκευών',
      ar: 'هندسة البناء', hi: 'निर्माण इंजीनियरिंग', zh: '建筑工程', ja: '建設エンジニアリング',
      id: 'teknik konstruksi', ms: 'kejuruteraan pembinaan', tl: 'construction engineering', vi: 'kỹ thuật xây dựng'
    }
  },
  {
    slug: 'lumber-millwork',
    name: 'Lumber & Millwork',
    subServices: ['Casework shop drawings', 'Cabinetry detailing', 'Custom millwork', 'Lumber take-offs', 'Architectural woodwork (AWI)', 'CNC-ready DXF/DWG output', 'Engineered wood framing'],
    t: {
      en: 'lumber and millwork drafting', es: 'carpintería y maderería', fr: 'menuiserie et bois d\'œuvre', de: 'Holzbau und Innenausbau', it: 'falegnameria e legname', pt: 'marcenaria e madeireira',
      nl: 'hout- en meubelmaakwerk', pl: 'stolarka i obróbka drewna', ru: 'плотницкие и столярные работы', sv: 'snickeri och timmer', no: 'snekkerarbeid', el: 'ξυλουργικές εργασίες',
      ar: 'الأخشاب والنجارة', hi: 'लकड़ी और मिलवर्क', zh: '木工和细木工', ja: '木材・造作工事',
      id: 'kayu dan millwork', ms: 'kayu dan kerja pertukangan', tl: 'lumber at millwork', vi: 'gỗ và mộc'
    }
  },
  {
    slug: 'rendering-animation',
    name: 'Rendering & Animation',
    subServices: ['Photorealistic exterior rendering', 'Interior visualization', 'Architectural walkthrough video', '360° VR tours', 'Construction animation', 'Product 3D animation', 'Real-time visualization (Twinmotion / Lumion)'],
    t: {
      en: 'rendering and animation services', es: 'renderizado y animación', fr: 'rendu et animation', de: 'Rendering und Animation', it: 'rendering e animazione', pt: 'renderização e animação',
      nl: 'rendering en animatie', pl: 'rendering i animacja', ru: 'рендеринг и анимация', sv: 'rendering och animation', no: 'rendering og animasjon', el: 'render και κινούμενα σχέδια',
      ar: 'العرض والرسوم المتحركة', hi: 'रेंडरिंग और एनिमेशन', zh: '渲染与动画', ja: 'レンダリングとアニメーション',
      id: 'rendering dan animasi', ms: 'rendering dan animasi', tl: 'rendering at animation', vi: 'kết xuất và hoạt hình'
    }
  },
  {
    slug: 'geotechnical-engineering',
    name: 'Geotechnical Engineering',
    subServices: ['Soil investigation reports', 'Foundation engineering', 'Slope stability analysis', 'Retaining wall design', 'Ground improvement', 'Pile design', 'Liquefaction studies'],
    t: {
      en: 'geotechnical engineering services', es: 'ingeniería geotécnica', fr: 'ingénierie géotechnique', de: 'Geotechnik', it: 'ingegneria geotecnica', pt: 'engenharia geotécnica',
      nl: 'geotechniek', pl: 'inżynieria geotechniczna', ru: 'геотехническая инженерия', sv: 'geoteknik', no: 'geoteknikk', el: 'γεωτεχνική μηχανική',
      ar: 'الهندسة الجيوتقنية', hi: 'जियोटेक्निकल इंजीनियरिंग', zh: '岩土工程', ja: '地盤工学',
      id: 'teknik geoteknik', ms: 'kejuruteraan geoteknik', tl: 'geotechnical engineering', vi: 'kỹ thuật địa kỹ thuật'
    }
  },
  {
    slug: 'oil-gas-energy',
    name: 'Oil, Gas, LNG & Energy',
    subServices: ['LNG facility design', 'Refinery engineering', 'Power plant design', 'Renewable energy infrastructure', 'Wind farm layout', 'Solar plant engineering', 'Offshore platform engineering'],
    t: {
      en: 'oil and gas engineering', es: 'ingeniería de petróleo y gas', fr: 'ingénierie pétrole et gaz', de: 'Öl- und Gas-Engineering', it: 'ingegneria petrolio e gas', pt: 'engenharia de óleo e gás',
      nl: 'olie- en gas-engineering', pl: 'inżynieria nafty i gazu', ru: 'нефтегазовая инженерия', sv: 'olje- och gasteknik', no: 'olje- og gassteknikk', el: 'μηχανική πετρελαίου και αερίου',
      ar: 'هندسة النفط والغاز', hi: 'तेल और गैस इंजीनियरिंग', zh: '石油天然气工程', ja: '石油ガスエンジニアリング',
      id: 'teknik minyak dan gas', ms: 'kejuruteraan minyak dan gas', tl: 'oil and gas engineering', vi: 'kỹ thuật dầu khí'
    }
  },
  {
    slug: 'premedia-services',
    name: 'Premedia Services',
    subServices: ['Pre-press production', 'Image retouching', 'Color management', 'Digital asset preparation', 'High-res scan correction', 'CMYK conversion', 'Proofing & soft proofing'],
    t: {
      en: 'premedia services', es: 'servicios premedia', fr: 'services prémédia', de: 'Premedia-Dienste', it: 'servizi premedia', pt: 'serviços premedia',
      nl: 'premedia diensten', pl: 'usługi premedia', ru: 'премедиа-услуги', sv: 'premediatjänster', no: 'premediatjenester', el: 'υπηρεσίες premedia',
      ar: 'خدمات ما قبل الطباعة', hi: 'प्रीमीडिया सेवाएं', zh: '印前服务', ja: 'プリメディアサービス',
      id: 'layanan premedia', ms: 'perkhidmatan premedia', tl: 'premedia services', vi: 'dịch vụ premedia'
    }
  },
  {
    slug: 'publishing-services',
    name: 'Publishing & Print',
    subServices: ['Page layout & typesetting', 'eBook conversion (ePub, MOBI)', 'Print-ready PDF generation', 'Magazine & journal design', 'Educational textbook layout', 'XML-first publishing', 'Accessibility (PDF/UA)'],
    t: {
      en: 'publishing and print services', es: 'servicios de publicación', fr: 'services d\'édition', de: 'Verlagsdienstleistungen', it: 'servizi di pubblicazione', pt: 'serviços de publicação',
      nl: 'publicatiediensten', pl: 'usługi publikacyjne', ru: 'издательские услуги', sv: 'förlagstjänster', no: 'forlagstjenester', el: 'εκδοτικές υπηρεσίες',
      ar: 'خدمات النشر', hi: 'प्रकाशन सेवाएं', zh: '出版与印刷服务', ja: '出版・印刷サービス',
      id: 'layanan penerbitan', ms: 'perkhidmatan penerbitan', tl: 'publishing services', vi: 'dịch vụ xuất bản'
    }
  }
];

// Language code -> display name (subset, used for chips)
export const LANG_LABELS = {
  en: 'English', es: 'Español', fr: 'Français', de: 'Deutsch', it: 'Italiano', pt: 'Português',
  nl: 'Nederlands', pl: 'Polski', ru: 'Русский', sv: 'Svenska', no: 'Norsk', el: 'Ελληνικά',
  ar: 'العربية', hi: 'हिन्दी', zh: '中文', ja: '日本語',
  id: 'Indonesia', ms: 'Melayu', tl: 'Filipino', vi: 'Tiếng Việt'
};
